import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { CloseIcon } from '@/src/components/icon/stroke/CloseIcon';
import { ClockIcon } from '@/src/components/icon/stroke/ClockIcon';
import { FlowPickersActionsBar } from './PickersActionBar';

export const flowTimePicker: Components<Theme>['MuiTimePicker'] = {
  defaultProps: {
    slots: {
      openPickerIcon: ClockIcon,
      clearIcon: CloseIcon,
      actionBar: FlowPickersActionsBar,
    },
    slotProps: {
      actionBar: {
        // keep just select button
        actions: ['accept'],
      },
      openPickerButton: {
        edge: false,
      },
      textField: {
        variant: 'filled',
      },
    },
  },
};

export const flowDesktopTimePicker: Components<Theme>['MuiDesktopTimePicker'] =
  flowTimePicker as Components<Theme>['MuiDesktopTimePicker'];

export const flowStaticTimePicker: Components<Theme>['MuiStaticTimePicker'] =
  flowTimePicker as Components<Theme>['MuiStaticTimePicker'];
